import { ChangeDetectionStrategy, Component, inject, InjectionToken, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

export type PopoverOverlayData = string | TemplateRef<void>;
export const POPOVER_OVERLAY_DATA = new InjectionToken<PopoverOverlayData>('Data to display in modal overlay');

@Component({
  selector: 'work-ui-popover-container',
  templateUrl: './popover-container.component.html',
  styleUrls: ['./popover-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgTemplateOutlet],
})
export class PopoverContainerComponent {
  popoverOverlayData = inject<PopoverOverlayData>(POPOVER_OVERLAY_DATA);

  get asTemplate(): TemplateRef<void> | false {
    return this.popoverOverlayData instanceof TemplateRef ? this.popoverOverlayData : false;
  }
}
